/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



$(document).ready(function($){
  $('.readmore').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'none';
  });
  $('.readless').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'block';
  });
});

$(document).ready(function($){
  if ($('.custom-video').length) {
    $(".custom-video video").prop('muted', true);
    $("#volume-control").click( function (){
      if( $("video").prop('muted') ) {
        $("video").prop('muted', false);
        $("#no-sound").addClass('hidden');
        $("#sound").removeClass('hidden');
      } else {
        $("video").prop('muted', true);
        $("#no-sound").removeClass('hidden');
        $("#sound").addClass('hidden');
      }
    });
  }
});

$(document).ready(function() {
  if ($('.custom-video').length) {
    var deskSrc = $('.videobg').data('desksrc');
    var mobSrc = $('.videobg').data('mobsrc');
    var v = new Array();
    v[0] = mobSrc;
    v[1] = deskSrc;
    function changeVid() {
      var video = document.getElementById('v1');
      if ($(window).width() < 641) {
        video.setAttribute("src", v[0]);
      } else {
        video.setAttribute("src", v[1]);
      }
      video.load();
    }
    changeVid();
    $('.videobg').trigger('play');
  }
});

// window.addEventListener('scroll', () => {
//   const sections = document.querySelectorAll('.CollectionInner__Products .ProductList .Grid__Cell');
//   const viewportHeight = window.innerHeight;
//   sections.forEach(section => {
//     const rect = section.getBoundingClientRect();
//     const sectionHeight = rect.height;
//     const halfSectionHeight = sectionHeight * 0.4;
//     section.classList.remove('secondary-open');
    
//     if (rect.top <= viewportHeight * 0.6 && rect.top + halfSectionHeight >= 0) {
//         // console.log(`Top 50% of section ${section.id} is visible`);
//       section.classList.add('secondary-open');
//     } 
//   });
// });

function reveal() {
  var reveals = document.querySelectorAll(".reveal");
  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 150;
    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active");
    } else {
      reveals[i].classList.remove("active");
    }
  }
}

window.addEventListener("scroll", reveal);

// To check the scroll position on page load
reveal();